import StaticUrls from '@/common/StaticUrls'

export type Type = 'EMPTY' | 'NO_CONTRACT' | 'NONCOMM' | 'DEFAULT'

export interface Item {
  title: string
  url: string
  cypressName?: string
  iconClass: string
}

export interface Mobileitem {
  title: string
  cypressName?: string
  url: string
}

export const items: Item[] = [
  {
    title: 'DASHBOARD',
    url: StaticUrls.homepage,
    cypressName: 'overview-link',
    iconClass: 'home',
  },
  {
    title: 'USER_PROFILE',
    url: StaticUrls.userProfile,
    cypressName: 'personal-data-link',
    iconClass: 'user',
  },
  {
    title: 'ACCOUNT_OVERVIEW',
    url: StaticUrls.accountOverview,
    cypressName: 'account-overview-link',
    iconClass: 'account',
  },
  {
    title: 'CONSUMPTION_OVERVIEW',
    url: StaticUrls.consumptionOverview,
    cypressName: 'consumption-overview-link',
    iconClass: 'consumption',
  },
  {
    title: 'CONTRACT_OVERVIEW',
    url: StaticUrls.deliveryAndContract,
    cypressName: 'contracts-overview-link',
    iconClass: 'contract',
  },
  {
    title: 'TELL_A_FRIEND',
    url: StaticUrls.tellAFriend,
    cypressName: 'refer-a-friend-link',
    iconClass: 'tell-a-friend',
  },
  {
    title: 'FAQ',
    url: StaticUrls.smartFAQ,
    cypressName: 'questions-and-answers-link',
    iconClass: 'faq',
  }
]

export const mobileItems: Mobileitem[] = [
  {
    title: 'DASHBOARD',
    cypressName: 'overview-mobile-link',
    url: StaticUrls.homepage
  },
  {
    title: 'USER_PROFILE',
    cypressName: 'personal-data-mobile-link',
    url: StaticUrls.userProfile
  },
  {
    title: 'ACCOUNT_OVERVIEW',
    cypressName: 'account-overview-mobile-link',
    url: StaticUrls.accountOverview
  },
  {
    title: 'CONSUMPTION_OVERVIEW',
    cypressName: 'consumption-overview-mobile-link',
    url: StaticUrls.consumptionOverview
  },
  {
    title: 'CONTRACT_OVERVIEW',
    cypressName: 'contracts-overview-mobile-link',
    url: StaticUrls.deliveryAndContract
  },
  {
    title: 'TELL_A_FRIEND',
    cypressName: 'refer-a-friend-mobile-link',
    url: StaticUrls.tellAFriend
  },
  {
    title: 'FAQ',
    cypressName: 'questions-and-answers-mobile-link',
    url: StaticUrls.smartFAQ
  }
]

export const menuEmpty = [] as string[]

export const menuNoContract = [
  'DASHBOARD',
  'USER_PROFILE',
  'FAQ'
]

export const menuNoncomm = [
  'DASHBOARD',
  'USER_PROFILE',
  'ACCOUNT_OVERVIEW',
  'CONTRACT_OVERVIEW',
  'TELL_A_FRIEND',
  'FAQ'
]

export const menuDefault = [
  'DASHBOARD',
  'USER_PROFILE',
  'ACCOUNT_OVERVIEW',
  'CONSUMPTION_OVERVIEW',
  'CONTRACT_OVERVIEW',
  'TELL_A_FRIEND',
  'FAQ'
]
